import { BlacklistProperties, MetadataSerialization } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-blacklist-properties',
	templateUrl: './blacklist-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlacklistPropertiesComponent extends BaseAuthoringPropertiesComponent<BlacklistProperties> {

	public override propertyConstructor: MetadataSerialization.Deserializable<any> = BlacklistProperties;

}